var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class SDBridgeSummaryReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.todaysDate = new Date().toDateString();
        this.headers = [
            'Bridge Owner',
            'Structurally Deficient',
            'Structurally Deficient Deck Area (sq. ft)',
            'Non Structurally Deficient',
            'Non Structurally Deficient Deck Area (sq. ft)'
        ];
        this.isGenerating = false;
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        titleService.setTitle(titleService.getTitle() + ' : Poor Bridge Condition Summary Report');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                this.bridgeKeys = JSON.parse(window.localStorage.getItem(x.get('id'))).bridgeKeys;
                this.loadReport();
            });
        });
    }
    loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getSDBridgeSummaryReportData(this.bridgeKeys).then((reportData) => {
            this.reportData = reportData;
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
    exportToCsv() {
        const filename = 'SDBridgeSummaryReport.csv';
        let finalValue = '';
        // Fix lint error
        const index0 = 0;
        const index1 = 1;
        const index2 = 2;
        const index3 = 3;
        finalValue = `${this.headers[index0]},${this.headers[index1]},${this.headers[index2]},${this.headers[index3]},\n`;
        if (this.reportData.projects.length > 0) {
            const projects = this.reportData.projects;
            for (const project of projects) {
                const commaGlobalReplaceRegEx = /,/g;
                finalValue += `${project.structurallyDeficient.replace(commaGlobalReplaceRegEx, '')},${project.structurallyDeficient.replace(commaGlobalReplaceRegEx, '')},${project.structurallyDeficientDeckArea.replace(commaGlobalReplaceRegEx, '')},${project.nonStructurallyDeficient.replace(commaGlobalReplaceRegEx, '')},${project.nonStructurallyDefDeckArea.replace(commaGlobalReplaceRegEx, '')},\n`;
            }
        }
        const blob = new Blob([finalValue], { type: 'text/csv;charset-utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        }
        else {
            const link = document.createElement('a');
            const myLink = link;
            if (myLink.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                const url = URL.createObjectURL(blob);
                myLink.setAttribute('href', url);
                myLink.setAttribute('download', filename);
                myLink.style.visibility = 'hidden';
                document.body.appendChild(myLink);
                myLink.click();
                document.body.removeChild(myLink);
            }
        }
    }
}
